import { render, staticRenderFns } from "./LayoutTextEdit.vue?vue&type=template&id=fdb1e5a4&"
import script from "./LayoutTextEdit.vue?vue&type=script&lang=js&"
export * from "./LayoutTextEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports